import styled from 'styled-components';
import { media } from 'designsystem/index';

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  
  ${media.desktop`
      flex-basis: 50%;
      min-height: 714px;
  `}
`;

export default TextWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/HeroImage/TextBlock/TextWrapper.jsx